<template>
  <div class="common-bottom-footer fb fb-main-center fb-cross-center">
    <md-button
      v-show="buttonConfig.customizeText"
      :type="buttonConfig.customizeType"
      :class="{ disabled: buttonConfig.customizeDisabled }"
      @click="$emit('customize')"
      >{{ buttonConfig.customizeText }}</md-button
    >
    <md-button
      v-show="buttonConfig.cancelText"
      type="submary"
      class="mr-16"
      :class="{ disabled: buttonConfig.cancelDisabled }"
      @click="$emit('cancel')"
      >{{ buttonConfig.cancelText }}</md-button
    >
    <md-button
      v-show="buttonConfig.confirmText"
      :class="{ disabled: buttonConfig.confirmDisabled }"
      @click="$emit('confirm')"
      >{{ buttonConfig.confirmText }}</md-button
    >
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    buttonConfig: {
      type: Object,
      default: (
        customizeText = '', // 自定义
        cancelText = '',
        confirmText = '',
        customizeType = 'primary',
        cancelDisabled = false,
        confirmDisabled = false,
        customizeDisabled = false
      ) => {
        return {
          customizeText,
          cancelText,
          confirmText,
          customizeType,
          cancelDisabled,
          confirmDisabled,
          customizeDisabled
        }
      }
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.common-bottom-footer {
  height: 60px;
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 34px;
  background: #ffffff;
  padding: 0 16px;
  .disabled {
    opacity: 0.28;
  }
}
</style>
